export const leadsConstants = {
    GET_LEADS_REQUEST: 'GET_LEADS_REQUEST',
    GET_LEADS_SUCCESS: 'GET_LEADS_SUCCESS',
    GET_LEADS_FAIL: 'GET_LEADS_FAIL',
}